import { useParams } from "react-router-dom";

import NetworkSettings from "../../../../../components/modules/providers/provider-management/components/management/NetworkSettings";
import Navigation from "../../../../../components/navigations/provider-management/detail/management/navigation";

export default function Template() {
  const { id } = useParams();

  return (
    <Navigation activeTab="network-settings" providerId={id}>
      <NetworkSettings />
    </Navigation>
  );
}
